import Chart from 'chart.js';

export default class Chartisan {
  constructor({ el, url, hooks }) {
    this.element = el;
    this.url = url;
    this.hooks = hooks;
    this.usedColours = [];

    this.retrieveData().then((data) => this.render(data));
  }

  retrieveData() {
    return fetch(this.url).then((response) => response.json());
  }

  render(details) {
    const canvas = this.element;
    if (canvas) {
      const ctx = canvas.getContext('2d');
      if (ctx) {
        // eslint-disable-next-line no-new
        new Chart(ctx, {
          type: 'line',
          data: {
            labels: details.chart.labels,
            datasets: details.datasets.map((dataset) => {
              const colour = this.randomColour(true);
              return {
                label: dataset.name,
                data: dataset.values,
                tension: 0.1,
                pointBackgroundColor: colour,
                borderColor: colour,
                borderWidth: 1,
                fill: false,
              };
            }),
          },
          options: {
            responsive: true,
            legend: this.hooks.legend,
            maintainAspectRatio: true,
            plugins: {
              tooltip: this.hooks.tooltip,
            },
            scales: {
              y: {
                min: 0,
                max: 100,
              },
            },
          },
        });
      }
    }
  }

  randomColour(unique = false) {
    let color = '#';

    do {
      const letters = '0123456789ABCDEF';
      color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
    } while (unique && this.usedColours.includes(color));

    return color;
  }
}
